import * as z from "zod";

export const ConfirmCancelOrderSchema = z.object({
  orderId: z.string(),
  customerEmail: z.string(),
  confirmCancel: z.boolean(),
});
export type ConfirmCancelOrder = z.infer<typeof ConfirmCancelOrderSchema>;
